import $ from 'jquery';

$( document ).ready(function() {

    $('.burger-menu').on('click', function(){
      $('.burger-menu div').toggleClass('white');
      $('.burger-menu2').toggleClass('hide');
      $('.burger-menu1, .burger-menu3').toggleClass('rotate');
    });
  
});